import { createSlice } from "@reduxjs/toolkit";
import {
  fetchEarningsSummaryReducer,
  fetchEarningsListReducer,
} from "../../reducer/earnings/nurseEarningsReducer";

import i18n from "../../i18n";
const initialState = {
  summary: null,
  list: [],
  pagination: { page: 1, limit: 10, total: 0, totalPages: 1 },
  isLoading: false,
  error: null,
};

const nurseEarningsSlice = createSlice({
  name: "nurseEarnings",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchEarningsSummaryReducer.fulfilled, (state, action) => {
        state.summary = action.payload || null;
      })
      .addCase(fetchEarningsListReducer.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchEarningsListReducer.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = action.payload?.earnings || [];
        state.pagination = {
          page: action.payload?.pagination?.page || 1,
          limit: action.payload?.pagination?.limit || 10,
          total: action.payload?.pagination?.total || 0,
          totalPages:
            action.payload?.pagination?.totalPages ||
            action.payload?.pagination?.total_pages ||
            1,
        };
      })
      .addCase(fetchEarningsListReducer.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || i18n.t("toast.failedToLoadEarnings");
      });
  },
});

export default nurseEarningsSlice.reducer;
